<template>
    
</template>
<script>
export default {
    created() {
        this.$router.push('/pages/maintenance')
    }
}
</script>